export interface AgentInfo {
  name: string;
  price: number;
  role: string;
  description: string;
}

export interface ParsedAgentMatch {
  name: string;
  price: number;
}

const AGENT_LINE_RE = /^[-*]\s+\*\*(.+?)\*\*\s*[—–-]\s*\$([0-9,]+)/;

export function extractAgentMatches(content: string): {
  matches: ParsedAgentMatch[];
  beforeText: string;
  afterText: string;
} {
  const lines = content.split("\n");
  const matchLines: number[] = [];
  const matches: ParsedAgentMatch[] = [];

  lines.forEach((line, idx) => {
    const m = AGENT_LINE_RE.exec(line.trim());
    if (m) {
      let name = m[1].trim();
      // Defensive: if the model bolded "Name — Role" together (e.g.
      // "**Oreon — Call Automation Specialist**"), keep only the prefix
      // before the first em-dash/en-dash separator so the cart sends
      // just "Oreon". We deliberately only match em-dash (—) and en-dash
      // (–), NOT the regular hyphen (-), because catalogue names may
      // legitimately contain hyphens. The chatbot always uses em-dash
      // between name and role.
      const sepMatch = name.match(/\s+[—–]\s+/);
      if (sepMatch && sepMatch.index !== undefined) {
        name = name.slice(0, sepMatch.index).trim();
      }
      const price = parseInt(m[2].replace(/,/g, ""), 10);
      matchLines.push(idx);
      matches.push({ name, price });
    }
  });

  if (matches.length === 0) {
    return { matches: [], beforeText: content, afterText: "" };
  }

  const firstMatchIdx = matchLines[0];
  const lastMatchIdx = matchLines[matchLines.length - 1];

  const beforeLines = lines.slice(0, firstMatchIdx);
  const afterLines = lines.slice(lastMatchIdx + 1);

  return {
    matches,
    beforeText: beforeLines.join("\n").trim(),
    afterText: afterLines.join("\n").trim(),
  };
}
